<template>
  <generic-modal
    size="large"
    :title="$t('visanet payment configuration')"
    icon="credit card"
    image="/images/icons/credit_card.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <generic-container
        v-bind:show_plus="true"
        icon="cogs"
        :title="$t('settings')"
        v-on:add="add_setting"
      >
        <div class="ui form">
          <div class="fields">
            <div class="eight column wide field">
              <label for="">{{ $t("wsdl url") }}</label>
              <input type="text" name="wsdl_url" v-model="setup.wsdl_url" />
            </div>
            <div class="eight column wide field">
              <div class="ui grid">
                <div class="row">
                  <div class="eight column wide field">
                    <label for="">{{ $t("sale message type") }}</label>
                    <input
                      type="text"
                      name="saleMessageType"
                      v-model="setup.saleMessageType"
                    />
                  </div>
                  <div class="eight column wide field">
                    <label for="">{{ $t("reverse message type") }}</label>
                    <input
                      type="text"
                      name="reverseMessageType"
                      v-model="setup.reverseMessageType"
                    />
                  </div>
                </div>
                <div class="row" style="padding-top: 0">
                  <div class="eight column wide field">
                    <label for="">{{ $t("void message type") }}</label>
                    <input
                      type="text"
                      name="voidMessageType"
                      v-model="setup.voidMessageType"
                    />
                  </div>
                  <div class="eight column wide field">
                    <label for="">{{ $t("timeout limit (ms)") }}</label>
                    <input type="text" name="timeout" v-model="setup.timeout" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="ui grid"
          v-if="setup.settings.length"
          style="margin-top: 10px"
        >
          <div class="four wide column">
            <div class="ui vertical fluid pointing menu" ref="visa_tabs">
              <a
                class="item"
                :data-tab="'t' + idx"
                v-for="(setting, idx) in setup.settings"
                :key="idx"
              >
                <i
                  class="settings icon"
                  :class="{ blue: setting.is_default }"
                ></i>
                {{ setting.name }}
              </a>
            </div>
          </div>
          <div class="twelve wide stretched column">
            <div
              class="ui tab segment"
              :data-tab="'t' + idx"
              v-for="(setting, idx) in setup.settings"
              :key="idx"
            >
              <div class="ui form">
                <div class="fields">
                  <div class="five wide column field">
                    <label for>{{ $t("name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="setup.settings[idx].name"
                    />
                  </div>
                  <div class="seven wide column field">
                    <label for>
                      <i class="settings icon"></i>
                    </label>
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="set_as_default"
                        v-model="setup.settings[idx].is_default"
                      />
                      <label>{{ $t("set as default") }}</label>
                    </div>
                  </div>
                  <div class="two wide column field">
                    <label for>
                      <i class="">{{ $t("options") }}</i>
                    </label>
                    <div
                      class="ui red icon button"
                      :data-tooltip="$t('delete')"
                      @click="remove_setting(idx)"
                    >
                      <i class="trash icon"></i>
                    </div>
                  </div>
                </div>
                <div class="ui dividing header">
                  {{ $t("visa merchant info") }}
                </div>
                <div class="three fields">
                  <div class="field">
                    <label for="">{{ $t("pos entry mode") }}</label>
                    <input
                      type="text"
                      name="posEntryMode"
                      v-model="setup.settings[idx].posEntryMode"
                    />
                  </div>
                  <div class="field">
                    <label for="">{{ $t("terminal id") }}</label>
                    <input
                      type="text"
                      name="terminalId"
                      v-model="setup.settings[idx].terminalId"
                    />
                  </div>
                  <div class="field">
                    <label for="">{{ $t("merchant") }}</label>
                    <input
                      type="text"
                      name="merchant"
                      v-model="setup.settings[idx].merchant"
                    />
                  </div>
                </div>
                <div class="two fields">
                  <div class="field">
                    <label for="">{{ $t("payment gateway ip") }}</label>
                    <input
                      type="text"
                      name="paymentGatewayIP"
                      v-model="setup.settings[idx].paymentGatewayIP"
                    />
                  </div>
                  <div class="field">
                    <label for="">{{ $t("audit number") }}</label>
                    <input
                      type="text"
                      name="auditNumber"
                      v-model="setup.settings[idx].auditNumber"
                    />
                  </div>
                </div>
                <div class="field">
                  <label for="">{{ $t("merchant user") }}</label>
                  <input
                    type="text"
                    name="merchantPasswd"
                    v-model="setup.settings[idx].merchantUser"
                  />
                </div>
                <div class="field">
                  <label for="">{{ $t("merchant password") }}</label>
                  <input
                    type="text"
                    name="merchantPasswd"
                    v-model="setup.settings[idx].merchantPasswd"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";
import { v4 } from "uuid";

export default {
  name: "VisaPaymentConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
  },
  computed: {},
  data() {
    return {
      setup: {
        settings: [],
        wsdl_url: "",
        saleMessageType: "",
        reverseMessageType: "",
        voidMessageType: "",
        timeout: "5000",
      },
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        // let settings = vm.settings;
        local_api(vm, "post", "/visa_payment/do-save-configuration", {
          s: vm.setup,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    add_setting() {
      let vm = this;
      vm.setup.settings.push({
        name: vm.$t("unnamed"),
        is_default: false,
        uuid: v4(),
      });
    },
    remove_setting(index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete setting?"),
        function() {
          vm.setup.settings.splice(index, 1);
        },
      );
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/visa_payment/do-get-configuration")
      .then((conf) => {
        if (conf) {
          vm.setup = conf;
          if (!vm.setup.timeout) vm.setup.timeout = "5000";
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {
    "setup.settings"() {
      let vm = this;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.visa_tabs)
          .find(".item")
          .tab();
      }, 500);
    },
  },
  updated: function() {},
};
</script>
